<template>
  <SvgBase iconName="Calendar" width="14" height="14">
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.34644 11.1242C9.21387 11.1242 9.08674 11.0715 8.993 10.9778C8.89926 10.8841 8.8466 10.7569 8.8466 10.6244V7.43442L8.57019 7.57238C8.51142 7.60232 8.44729 7.62034 8.38152 7.62538C8.31574 7.63043 8.24962 7.62241 8.18696 7.60178C8.12431 7.58115 8.06635 7.54832 8.01644 7.50518C7.96653 7.46205 7.92566 7.40946 7.89617 7.35045C7.86668 7.29144 7.84916 7.22718 7.84463 7.16136C7.8401 7.09555 7.84864 7.0295 7.86975 6.967C7.89087 6.90451 7.92415 6.84681 7.96768 6.79724C8.0112 6.74767 8.0641 6.7072 8.12334 6.67817L9.12301 6.17834C9.1992 6.13995 9.28397 6.12175 9.3692 6.12547C9.45443 6.1292 9.53728 6.15472 9.60984 6.19959C9.6824 6.24447 9.74223 6.30721 9.78363 6.38181C9.82502 6.45641 9.84659 6.54038 9.84627 6.62569V10.6244C9.84627 10.7569 9.79361 10.8841 9.69987 10.9778C9.60613 11.0715 9.479 11.1242 9.34644 11.1242ZM6.78951 8.31448C6.96552 8.07981 7.06106 7.79459 7.06192 7.50125C7.06152 7.13682 6.91658 6.78743 6.65889 6.52974C6.4012 6.27205 6.05181 6.12711 5.68738 6.12671C5.43553 6.12621 5.18843 6.19519 4.97326 6.32606C4.75808 6.45692 4.58318 6.64461 4.46778 6.86846C4.43759 6.92675 4.41917 6.99041 4.41358 7.05582C4.40799 7.12123 4.41534 7.18709 4.4352 7.24966C4.45507 7.31222 4.48706 7.37026 4.52936 7.42047C4.57166 7.47067 4.62342 7.51205 4.68171 7.54224C4.74 7.57243 4.80366 7.59085 4.86907 7.59644C4.93447 7.60203 5.00034 7.59468 5.06291 7.57482C5.12547 7.55495 5.18351 7.52296 5.23371 7.48066C5.28391 7.43837 5.32529 7.3866 5.35549 7.32831C5.38618 7.26928 5.43204 7.21948 5.48834 7.18403C5.54464 7.14857 5.60937 7.12875 5.67587 7.12658C5.74237 7.12441 5.80825 7.13998 5.86674 7.17169C5.92523 7.2034 5.97424 7.2501 6.00871 7.30701C6.04319 7.36391 6.0619 7.42897 6.06292 7.4955C6.06394 7.56203 6.04724 7.62763 6.01452 7.68556C5.98181 7.7435 5.93427 7.79169 5.87678 7.82518C5.81928 7.85867 5.75391 7.87625 5.68738 7.87613C5.55481 7.87613 5.42768 7.92879 5.33394 8.02253C5.2402 8.11626 5.18754 8.2434 5.18754 8.37596C5.18754 8.50853 5.2402 8.63566 5.33394 8.7294C5.42768 8.82314 5.55481 8.8758 5.68738 8.8758C6.03176 8.8758 6.31217 9.1562 6.31217 9.50059C6.31217 9.84498 6.03176 10.1254 5.68738 10.1254C5.34299 10.1254 5.06258 9.84498 5.06258 9.50059C5.06258 9.36803 5.00993 9.24089 4.91619 9.14715C4.82245 9.05342 4.69532 9.00076 4.56275 9.00076C4.43019 9.00076 4.30305 9.05342 4.20932 9.14715C4.11558 9.24089 4.06292 9.36803 4.06292 9.50059C4.06292 10.3963 4.79168 11.1251 5.68738 11.1251C6.58308 11.1251 7.31184 10.3963 7.31184 9.50059C7.31144 9.27753 7.26482 9.05697 7.17492 8.85282C7.08502 8.64868 6.95379 8.46538 6.78951 8.31448Z"
        :fill="color"
      />
      <rect
        x="0.5"
        y="2.25"
        width="13"
        height="11.25"
        rx="2.5"
        :stroke="color"
      />
      <line
        x1="4.875"
        y1="0.5"
        x2="4.875"
        y2="3"
        :stroke="color"
        stroke-linecap="round"
      />
      <line
        x1="9.25"
        y1="0.5"
        x2="9.25"
        y2="3"
        :stroke="color"
        stroke-linecap="round"
      />
    </svg>
  </SvgBase>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import SvgBase from '../SvgBase.vue'

@Options({
  components: {
    SvgBase,
  },
  props: {
    color: {
      type: String,
      default: 'currentColor',
    },
  },
})
export default class IconCalendar extends Vue {}
</script>
